var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { IconAlertCircleFill, IconSize } from '@amzn/atoz-web/Icons';
import { Card } from '@amzn/atoz-web/Card';
export var GenericErrorView = function (_a) {
    var titleText = _a.titleText, bodyText = _a.bodyText, dataTestId = _a.dataTestId, buttonAction = _a.buttonAction, role = _a.role;
    var t = useTranslation().t;
    var titleString = titleText || t('ess_error_wrapper_message');
    var bodyString = bodyText || t('ess_error_wrapper_try_again');
    var buttonString = t('ess_shifts_dashboard_errorModal_tryAgain');
    var testId = dataTestId || 'GenericErrorView';
    var action = function () {
        if (buttonAction) {
            buttonAction();
        }
        else {
            window.location.reload();
        }
    };
    return (React.createElement(StyledCard, { "data-testid": testId, role: role },
        React.createElement(Row, { margin: { bottom: 'S200' }, alignItems: "center" },
            React.createElement(IconAlertCircleFill, { color: "red60-alpha90", size: IconSize.Medium, margin: { right: 'S200' } }),
            React.createElement(Text, { fontSize: "T300" }, titleString)),
        React.createElement(Text, { fontSize: "T200" }, bodyString),
        React.createElement(ButtonsRow, { justifyContent: "flex-end" },
            React.createElement(StyledButton, { variant: ButtonVariant.Primary, onClick: action, dataTestId: "GenericErrorViewButton" }, buttonString))));
};
var ButtonsRow = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    return "\n    margin-top: ".concat(theme.selectors.space('S200'), "px;\n");
});
var StyledButton = styledWithTheme(Button)(function (_a) {
    var theme = _a.theme;
    return "\n    margin-top: ".concat(theme.selectors.space('S600'), "px;\n");
});
var StyledCard = styledWithTheme(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: none;\n    display: grid;\n"], ["\n    border: none;\n    display: grid;\n"])));
var templateObject_1;
